import { Box } from '@mui/material';
import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ART_DES_ANTRAGS, FORM_FIELDS_TYPES, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { EmailValidation, PhoneNumberValidation, Required } from 'src/lib/validation/ValidationTypes';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { mapCustomFormStrucIndex } from 'src/utils/formStruc';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';

// import schemas
import { get } from 'lodash';
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const AnsprechpartnerGlobal: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	return (
		<>
			<ApplicationHeading title='Ansprechpartner' description={PLATZHALTER_TEXT} />

			<Box sx={{ mt: '1rem' }}>
				<CreateForm
					formStruc={formAnsprechpartner(application)}
					formValues={application}
					updateFormValuesFunc={setApplicationProperty}
					readOnly={updatedReadOnly}
					size='small'
				/>
			</Box>
			<Box sx={{ mt: '1rem' }}>
				<CreateForm
					formStruc={formStrucZeichnungberechtigte(application, updatedReadOnly)}
					formValues={application}
					updateFormValuesFunc={setApplicationProperty}
					readOnly={updatedReadOnly}
					size='small'
				/>
			</Box>
			{/* <Box sx={{ mt: '1rem' }}>
				<CreateForm
					formStruc={formStrucZeichnungberechtigteVertretung()}
					formValues={application}
					updateFormValuesFunc={setApplicationProperty}
					readOnly={updatedReadOnly}
					size='small'
				/>
			</Box> */}
		</>
	);
};

export default AnsprechpartnerGlobal;

const formAnsprechpartner = (_application: any) => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Antragstellende_Organisation_Ansprechpartnerin,
					tableLabel: 'Ansprechpersonen für dieses Projekt',
					type: FORM_FIELDS_TYPES.editableTable,
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};
const formStrucZeichnungberechtigte = (application: any, updatedReadOnly: boolean): FormStrucItem[] => {
	const artDesAntrags = get(application, P.Allgemein_Art_Des_Antrags.path, '');
	const isFormantrag = artDesAntrags === ART_DES_ANTRAGS.Formantrag;
	const isDisabled = isFormantrag ? true : updatedReadOnly;
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Antragstellende_Organisation_Zeichnungsberechtigte,
					tableLabel: 'Vertretungsberechtigte gemäß Handelsregister, Satzung oder Gesetz',
					type: FORM_FIELDS_TYPES.editableTable,
					disabled: isDisabled,
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

/**
 * *********************************************************************************************************
 * **************************************** BITTE LESEN ****************************************************
 * *********** Erstmal nur auskommentieren. Es kann sein, dass HA noch mal diese Tabelle haben wil *********
 * *********************************************************************************************************
 */
// const formStrucZeichnungberechtigteVertretung = (): FormStrucItem[] => {
// 	let struc: FormStrucItem[] = [
// 		{
// 			fields: [
// 				{
// 					...P.Antragstellende_Organisa_0244561511_ektbeantragung_Undabwicklung,
// 					tableLabel: 'Vertretungsberechtigte im Rahmen der Projektbeantragung und -abwicklung',
// 					type: FORM_FIELDS_TYPES.editableTable,
// 				},
// 			],
// 			userProps: { columnToDivide: 1 },
// 		},
// 	];
// 	return struc;
// };

// custom formstruc for specific table validation
const customFormStrucAnsprechpartner = () => {
	return [
		{
			fields: [
				P.Antragstellende_Organisation_Ansprechpartnerin.schema.attributes.Vorname,
				P.Antragstellende_Organisation_Ansprechpartnerin.schema.attributes.Nachname,
			],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [
				{
					...P.Antragstellende_Organisation_Ansprechpartnerin.schema.attributes.Telefonnummer,
					validation: [{ validateFunction: Required }, { validateFunction: PhoneNumberValidation }],
				},
				{
					...P.Antragstellende_Organisation_Ansprechpartnerin.schema.attributes.E_45_Mail_45_Adresse,
					validation: [{ validateFunction: Required }, { validateFunction: EmailValidation }],
				},
			],
			userProps: { columnToDivide: 2 },
		},
	];
};
// custom formstruc for specific table validation
// const customFormStrucZeichnungsberechtigte = () => {
// 	return [
// 		{
// 			fields: [
// 				P.Antragstellende_Organisation_Zeichnungsberechtigte.schema.attributes.Vorname,
// 				P.Antragstellende_Organisation_Zeichnungsberechtigte.schema.attributes.Nachname,
// 			],
// 			userProps: { columnToDivide: 2 },
// 		},
// 		{
// 			fields: [
// 				{
// 					...P.Antragstellende_Organisation_Zeichnungsberechtigte.schema.attributes.Telefonnummer,
// 					validation: [{ validateFunction: Required }, { validateFunction: PhoneNumberValidation }],
// 				},
// 				{
// 					...P.Antragstellende_Organisation_Zeichnungsberechtigte.schema.attributes.E_45_Mail_45_Adresse,
// 					validation: [{ validateFunction: Required }, { validateFunction: EmailValidation }],
// 				},
// 			],
// 			userProps: { columnToDivide: 2 },
// 		},
// 	];
// };
// custom formstruc for specific table validation
// const customFormStrucZeichnungsberechtigteVertretung = () => {
// 	return [
// 		{
// 			fields: [
// 				P.Antragstellende_Organisa_0244561511_ektbeantragung_Undabwicklung.schema.attributes.Vorname,
// 				P.Antragstellende_Organisa_0244561511_ektbeantragung_Undabwicklung.schema.attributes.Nachname,
// 			],
// 			userProps: { columnToDivide: 2 },
// 		},
// 		{
// 			fields: [
// 				{
// 					...P.Antragstellende_Organisa_0244561511_ektbeantragung_Undabwicklung.schema.attributes.Telefonnummer,
// 					validation: [{ validateFunction: Required }, { validateFunction: PhoneNumberValidation }],
// 				},
// 				{
// 					...P.Antragstellende_Organisa_0244561511_ektbeantragung_Undabwicklung.schema.attributes.E_45_Mail_45_Adresse,
// 					validation: [{ validateFunction: Required }, { validateFunction: EmailValidation }],
// 				},
// 			],
// 			userProps: { columnToDivide: 2 },
// 		},
// 	];
// };

export const getFormStrucAnsprechpartnerGlobal = (application: any) => {
	const orgaAPWithIndex = mapCustomFormStrucIndex(application, customFormStrucAnsprechpartner(), P.Antragstellende_Organisation_Ansprechpartnerin);
	// const orgaZBWithIndex = mapCustomFormStrucIndex(
	// 	application,
	// 	customFormStrucZeichnungsberechtigte(),
	// 	P.Antragstellende_Organisation_Zeichnungsberechtigte
	// );

	return concat(orgaAPWithIndex);
};
